module.exports = __webpack_public_path__ + "che-pizza.svg?809aad5d01133a239cbc108a419b253a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/che-pizza.svg
// module id = 131
// module chunks = 0